import React, { useState } from "react";
import { Box, Divider, Typography } from '@mui/material';
import FormularioCertificados from "../pages/Certificados/FormularioCertificados";
import ListaCertificados from "../pages/Certificados/ListaCertificados";
import FormularioInfoCertificados from "../pages/Certificados/FormularioInfoCertificados";
import ListaInfoCertificados from "../pages/Certificados/ListaInfoCertificados";
import CertificadosPages from "../pages/Certificados/CertificadosPages";

const DashboardCertificadosWeb = () => {
    const [certificadosSeleccionado, setCertificadosSeleccionado] = useState(null);
    const [infoCertificadosSeleccionado, setInfoCertificadosSeleccionado] = useState(null);
    
    // Función para manejar la edición del Certificados
    const handleEditarCertificados = (certificado) => {
        setCertificadosSeleccionado(certificado);
        console.log('Estoy en DashboardCertificados ' + certificado);
    };

    // Función para manejar la edición del infoCertificados
    const handleEditarInfoCertificados = (infocertificado) => {
        setInfoCertificadosSeleccionado(infocertificado);
        console.log('Estoy en DashboardCertificados ' + infocertificado);
    };
    return(
        <Box sx={{
            gap: '20px',
            margin: '10px 5px',
            textAlign: 'center',
            '@media (max-width: 600px)': {  // En móviles
                flexDirection: 'column', // Asegurarse que esté en columna
                width: '95%',
                gap: '20px',
                margin: '1% 5%',
            },
        }}>
            <Typography 
                variant='h5' 
                sx={{ 
                    width: 'auto',
                    alignItems: 'center',
                    textAlign: 'center',
                    '@media (max-width: 600px)': {  // Ajustes para móviles
                        fontSize: '1.25rem',  // Tamaño más pequeño para la tipografía
                        margin: '1% 5%',
                    },
                }}
            >
                Sección de mis certificados
            </Typography>

            <Divider 
                sx={{
                    backgroundColor: '#8E0505',
                    width: '100%', // El ancho se ajusta a todo el espacio disponible
                    height: '0%',  // Puede ajustar el grosor aquí, aunque este valor es 0
                    margin: '1% 0%',
                    borderWidth: '0.1px',
                }} 
            />
            <Box sx={{
                display: 'flex', 
                flexDirection: 'column', // En pantallas pequeñas, columna, en otras también columna
                gap: '20px',
                margin: '3% 0%',
            }}>

                {/* Agregar Certificados */}
                {<FormularioCertificados certificadoSeleccionado={certificadosSeleccionado}/>}

                {/* lista de Certificados */}
                <ListaCertificados onEditar={handleEditarCertificados}/>

            </Box>

            
            <Typography 
                    variant='h5' 
                    sx={{ 
                        width: 'auto',
                        alignItems: 'center',
                        textAlign: 'center',
                        '@media (max-width: 600px)': {  // Ajustes para móviles
                            fontSize: '1.25rem',  // Tamaño más pequeño para la tipografía
                            margin: '1% 5%',
                        },
                    }}
                >
                    Sección de la información de mis certificados
                </Typography>

                <Divider 
                    sx={{
                        backgroundColor: '#8E0505',
                        width: '100%', // El ancho se ajusta a todo el espacio disponible
                        height: '0%',  // Puede ajustar el grosor aquí, aunque este valor es 0
                        margin: '1% 0%',
                        borderWidth: '0.1px',
                    }} 
                />

            <Box sx={{
                display: 'flex', 
                flexDirection: 'column', // En pantallas pequeñas, columna, en otras también columna
                gap: '20px',
                margin: '3% 0%',
            }}>

                {/*Formulario para agregar el contenido a la página web */}
                <FormularioInfoCertificados infoCertificadosSeleccionado={infoCertificadosSeleccionado}/>

                {/*Lista de la informació que se muestra en la pagina de handleEditarInfoCertificados*/}
                <ListaInfoCertificados onEditar={handleEditarInfoCertificados} />

            </Box>

            <CertificadosPages/>
        </Box>
    );
}

export default DashboardCertificadosWeb;